<template>
  <div class="footer">
    <div class="footer-1">
      <div class="footer-1-1">
        <div class="title-1">About Marco</div>
        <div class="text-1">
          We are dedicated to offering the lowest prices and the absolute best service, period our friendly,
          knowledgeable staff is ready to assist you with any questions you might have, and we will ship your order
          promptly and efficiently, we are committed to you.
        </div>
      </div>
      <div class="footer-nav">
        <div class="title-1">Company</div>
        <div class="text-1" @click="navigateTo('/about')">About Us</div>
        <div class="text-1" @click="navigateTo('/contact')">Contact Us</div>
        <div class="text-1" @click="navigateTo('/where-to-buy')">Where to buy</div>
      </div>
      <div class="footer-nav">
        <div class="title-1">Support</div>
        <div class="text-1" @click="navigateTo('/download')">Download</div>
        <div class="text-1" @click="navigateTo('/help')">FAQ's</div>
        <div class="text-1" @click="navigateTo('/warranty')">Warranty&Returns</div>
      </div>
      <div class="footer-nav">
        <div class="title-1">Account</div>
        <div class="text-1" @click="navigateTo('/member/accountDashboard')">My Account</div>
        <div class="text-1" @click="navigateTo('/orderStatus')">Order Status</div>
        <div class="text-1" @click="navigateTo('/MarcoRewards')">Marco Rewards</div>
      </div>
      <div v-if="false" class="payment-methods">
        <div class="title-1">Payment Methods Accepted</div>
        <div class="flex-d">
          <img src="../assets/image/footer-right-1.png" alt="" />
          <img src="../assets/image/footer-right-2.png" alt="" />
          <img src="../assets/image/footer-right-3.png" alt="" />
          <img src="../assets/image/footer-right-4.png" alt="" />
        </div>
      </div>
    </div>
    <div class="footer-2">
      <div class="flex-c">
        <span class="flex-c-title"> Follow us </span>
        <div class="flex-d-2">
          <!-- instagram -->
          <div
            class="social-link"
            @click="
              linkHandler('https://www.instagram.com/group_marco_autoparts', {
                external: true,
              })
            "
          >
            <img
              v-bind="socialImage('instagram')"
              alt="Instagram"
              class="social-icon social-icon--instagram"
            />
          </div>
          <!-- facebook -->
          <div
            class="social-link"
            @click="
              linkHandler('https://www.facebook.com/automarco.net/', {
                external: true,
                link: '_blank',
              })
            "
          >
            <img
              v-bind="socialImage('facebook')"
              alt="Facebook"
              class="social-icon social-icon--facebook"
            />
          </div>
          <!-- tiktok -->
          <div
            class="social-link"
            @click="
              linkHandler('https://www.tiktok.com/@marco_auto_parts', {
                external: true,
              })
            "
          >
            <img
              v-bind="socialImage('tiktok')"
              alt="TikTok"
              class="social-icon social-icon--tiktok"
            />
          </div>
          <!-- x -->
          <div class="social-link" @click="linkHandler('https://x.com/3940883850_', { external: true })">
            <img
              v-bind="socialImage('twitter')"
              alt="Twitter X"
              class="social-icon social-icon--twitter"
            />
          </div>
          <!-- youtube -->
          <div class="social-link" @click="linkHandler('https://www.youtube.com/@auto-marco-c', { external: true })">
            <img
              v-bind="socialImage('youtube')"
              alt="YouTube"
              class="social-icon social-icon--youtube"
            />
          </div>
          <!-- weChat -->
          <div class="social-link">
            <a-popover trigger="hover">
              <template #title>
                <p class="QR-title">Scan to follow</p>
              </template>
              <template #content>
                <img src="@/assets/image/QRCode.png" alt="" class="QR-code" />
              </template>
              <img
                v-bind="socialImage('wechat')"
                alt="WeChat"
                class="social-icon social-icon--wechat"
              />
            </a-popover>
          </div>
        </div>
      </div>
      <div class="footer-cc">Copyright(c)MARCO GENUINE PARTS CO.,LTD ALL Rights Reserved</div>
    </div>
    <div class="footer-bottom" v-show="!closeBottom">
      <img src="../assets/image/close.png" alt="" class="close-img" @click="closeBottom = true" />
      <div class="footer-bottom-1">This site uses cookies accroding to privacy policy.</div>
      <div class="footer-bottom-2">
        <div class="bottom-button">I agree</div>
        <div class="bottom-button">I do not agree</div>
      </div>
    </div>
  </div>
</template>

<script setup>
const closeBottom = ref(false);
const runtimeConfig = useRuntimeConfig();
const imageBase = (runtimeConfig.app?.baseURL || "/").replace(/\/?$/, "/");
const socialImage = (name) => {
  const prefix = `${imageBase}image/socialMedia/optimized/${name}-webp-`;
  return {
    src: `${prefix}128x128.webp`,
    srcset: `${prefix}128x128.webp 128w, ${prefix}256x256.webp 256w`,
    sizes: "3vw",
    width: 128,
    height: 128,
    loading: "lazy",
    decoding: "async",
  };
};

// const isShowQRCode = ref(false);

// const showQRCodeHandler = (flag) => {
//   isShowQRCode.value = flag;
//   window.open(
//     "https://weixin.qq.com/r/mp/gUjw6GLEcD8PrSaL9x2T",
//     "_blank",
//     "noopener,noreferrer"
//   );
// };

const linkHandler = (url, options = {}) => {
  if (options.external) {
    // 在新标签页打开外部链接
    window.open(url, "_blank", "noopener,noreferrer");
  } else {
    // 内部路由处理
    this.$router?.push(url);
  }
};
</script>
<style lang="less" scoped>
.text-1 {
  line-height: 1.5;
  cursor: pointer;
  margin-bottom: 15px;

  &:hover {
    color: #d41819;
  }
}

.title-1 {
  font-family: Galvji, sans-serif;
  font-weight: bold;
  font-size: 28px;
  color: #ffffff;
  margin-bottom: 26px;
}

.flex-c {
  display: flex;
  align-items: center;
  margin-top: 100px;

  .flex-c-title {
    margin-right: 28px;
    font-family: Galvji, sans-serif;
    font-weight: bold;
    font-size: 28px;
    color: #ffffff;
  }

  margin-bottom: 28px;
}

.flex-d {
  display: flex;

  img {
    width: 91px;
    height: 45px;
    margin-right: 7px;
  }
}

.flex-d-2 {
  display: flex;
  align-items: center;
  gap: clamp(4px, 0.35vw, 8px);

  .social-link {
    width: clamp(34px, 3vw, 58px);
    height: clamp(34px, 3vw, 58px);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .social-icon {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: contain;
    }
  }
}

.footer {
  // height: 486px;
  width: 100%;
  background-color: #231815;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 50px;

  // padding-bottom:26px ;
  .footer-1 {
    width: 86%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: minmax(320px, 1.35fr) repeat(3, minmax(150px, 0.65fr));
    column-gap: 72px;
    justify-content: center;
    color: #fff;
    font-family: Galvji, sans-serif;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
  }

  .footer-1-1 {
    max-width: 480px;
  }

  .footer-nav {
    min-width: 0;
  }

  .footer-2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    padding-bottom: 26px;
  }
}

.footer-cc {
  font-family: Galvji, sans-serif;
  font-weight: 400;
  font-size: 24px;
  color: #ffffff;
}

.footer-bottom {
  position: relative;
  overflow: hidden;

  .close-img {
    position: absolute;
    width: 24px;
    top: 19px;
    right: 19px;
    cursor: pointer;
  }

  // width: 1920px;
  height: 204px;
  background: #898989;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .footer-bottom-1 {
    font-family: Galvji, sans-serif;
    font-weight: bold;
    font-size: 22px;
    color: #ffffff;
    margin-bottom: 19px;
  }

  .footer-bottom-2 {
    width: 440px;
    display: flex;
    justify-content: space-between;

    .bottom-button {
      width: 169px;
      height: 35px;
      background: #d41819;
      font-family: Inter, Inter;
      font-weight: 400;
      font-size: 22px;
      color: #ffffff;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}

.QR-title {
  text-align: center;
  font-size: 1vw;
  margin-bottom: 0;
}

.QR-code {
  display: block;
  height: 10vw;
  width: 10vw;
  margin: 0 auto;
}
</style>
